var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyDocumentsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 56,
    viewBox: "0 0 102 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EmptyDocuments",
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9167 9.16797C90.8712 9.16797 92.4556 10.7524 92.4556 12.7069C92.4556 14.6613 90.8712 16.2457 88.9167 16.2457H68.6945C70.649 16.2457 72.2334 17.8302 72.2334 19.7846C72.2334 21.7391 70.649 23.3235 68.6945 23.3235H79.8167C81.7712 23.3235 83.3556 24.9079 83.3556 26.8624C83.3556 28.8169 81.7712 30.4013 79.8167 30.4013H74.6732C72.2089 30.4013 70.2112 31.9857 70.2112 33.9402C70.2112 34.2632 70.2733 34.5786 70.3976 34.8865C71.3633 37.2786 75.2646 37.1335 76.4144 39.4428C76.6506 39.9172 76.7834 40.4521 76.7834 41.018C76.7834 42.9724 75.199 44.5569 73.2445 44.5569H31.2834C29.3289 44.5569 27.7445 42.9724 27.7445 41.018C27.7445 39.0635 29.3289 37.4791 31.2834 37.4791H11.5667C9.61225 37.4791 8.02783 35.8947 8.02783 33.9402C8.02783 31.9857 9.61225 30.4013 11.5667 30.4013H31.7889C33.7434 30.4013 35.3278 28.8169 35.3278 26.8624C35.3278 24.9079 33.7434 23.3235 31.7889 23.3235H19.1501C17.1956 23.3235 15.6112 21.7391 15.6112 19.7846C15.6112 17.8302 17.1956 16.2457 19.1501 16.2457H39.3723C37.4178 16.2457 35.8334 14.6613 35.8334 12.7069C35.8334 10.7524 37.4178 9.16797 39.3723 9.16797H88.9167ZM88.9167 23.3235C90.8712 23.3235 92.4556 24.9079 92.4556 26.8624C92.4556 28.8169 90.8712 30.4013 88.9167 30.4013C86.9623 30.4013 85.3778 28.8169 85.3778 26.8624C85.3778 24.9079 86.9623 23.3235 88.9167 23.3235Z",
    fill: "#C7E4FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.462 9.16821L67.1646 43.4665L67.5871 46.9074C67.7232 48.016 66.9349 49.0249 65.8264 49.161L36.2209 52.7961C35.1124 52.9322 34.1034 52.1439 33.9673 51.0354L29.4094 13.9137C29.3413 13.3595 29.7354 12.855 30.2897 12.7869C30.2932 12.7865 30.2967 12.7861 30.3002 12.7856L32.7564 12.5102L62.462 9.16821ZM34.7425 12.2874L37.0615 12.0273L34.7425 12.2874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7425 12.2874L37.0615 12.0273M62.462 9.16821L67.1646 43.4665L67.5871 46.9074C67.7232 48.016 66.9349 49.0249 65.8264 49.161L36.2209 52.7961C35.1124 52.9322 34.1034 52.1439 33.9673 51.0354L29.4094 13.9137C29.3413 13.3595 29.7354 12.855 30.2897 12.7869C30.2932 12.7865 30.2967 12.7861 30.3002 12.7856L32.7564 12.5102L62.462 9.16821Z",
    stroke: "#1E93FF",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.182 11.3261L65.4386 42.4096L65.8214 45.528C65.9448 46.5325 65.24 47.4457 64.2473 47.5676L37.735 50.8229C36.7423 50.9448 35.8376 50.2292 35.7142 49.2247L31.5939 15.6676C31.5259 15.1134 31.92 14.6089 32.4743 14.5408L35.7541 14.1381",
    fill: "#E8F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7543 2.72217H40.7228C40.3389 2.72217 39.9913 2.87778 39.7397 3.12937C39.4881 3.38096 39.3325 3.72853 39.3325 4.11245V42.5347C39.3325 42.9186 39.4881 43.2662 39.7397 43.5177C39.9913 43.7693 40.3389 43.9249 40.7228 43.9249H70.5506C70.9345 43.9249 71.2821 43.7693 71.5337 43.5177C71.7853 43.2662 71.9409 42.9186 71.9409 42.5347V10.9045C71.9409 10.5357 71.7943 10.1819 71.5334 9.92117L64.7371 3.12907C64.4763 2.86853 64.1229 2.72217 63.7543 2.72217Z",
    fill: "white",
    stroke: "#1E93FF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M63.9785 3.30469V9.1677C63.9785 10.0053 64.6576 10.6844 65.4952 10.6844H69.5061",
    stroke: "#1E93FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lines",
    d: "M44.7676 36.4679H57.912M44.7676 10.6846H57.912H44.7676ZM44.7676 16.7512H66.5065H44.7676ZM44.7676 23.3235H66.5065H44.7676ZM44.7676 29.8957H66.5065H44.7676Z",
    stroke: "#1E93FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDocumentsIcon);
export default __webpack_public_path__ + "static/media/EmptyDocumentsIcon.b19df841f1e5a862cebcde54f641fd59.svg";
export { ForwardRef as ReactComponent };